import { assign, fromPromise, setup } from "xstate";

type DeletionContext = {
  itemId: string;
  /** Entity type to delete (e.g. "page"). Generic across domains. */
  itemType: string;
  error: string | null;
};

type DeletionEvent =
  | { type: "DELETE"; itemId: string; itemType: DeletionContext["itemType"] }
  | { type: "CANCEL" };

export const deletionMachine = setup({
  // Schema Definition Pattern for XState v5 type inference
  // oxlint-disable-next-line typescript/no-unsafe-type-assertion
  types: {} as {
    context: DeletionContext;
    events: DeletionEvent;
  },
  actors: {
    deleteActor: fromPromise(async ({ input }: { input: { id: string; type: string } }) => {
      await Promise.resolve();
      return input;
    }),
  },
}).createMachine({
  id: "deletion",
  initial: "idle",
  context: {
    itemId: "",
    itemType: "page",
    error: null,
  },
  states: {
    idle: {
      on: {
        DELETE: {
          target: "deleting",
          actions: assign(({ event }) => ({
            itemId: event.itemId,
            itemType: event.itemType,
          })),
        },
      },
    },
    deleting: {
      invoke: {
        src: "deleteActor",
        input: ({ context }) => ({ id: context.itemId, type: context.itemType }),
        onDone: "success",
        onError: {
          target: "error",
          actions: assign({
            error: ({ event }) =>
              event.error instanceof Error ? event.error.message : "Deletion failed",
          }),
        },
      },
    },
    success: {
      always: "idle",
    },
    error: {
      on: {
        DELETE: "deleting",
      },
    },
  },
});
